var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.693,
    cy: 28.5465,
    r: 23.4078,
    fill: "#7133BA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.693,
    cy: 24.0875,
    r: 23.4078,
    fill: "#5916AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3268 23.4674L35.4795 15.3148C36.222 14.5744 36.222 13.3725 35.4795 12.6301C34.7391 11.8876 33.5371 11.8876 32.7947 12.6301L24.6423 20.7827L16.4894 12.6301C15.747 11.8876 14.5452 11.8876 13.8049 12.6301C13.0624 13.3725 13.0624 14.5744 13.8049 15.3148L21.9574 23.4674L13.8049 31.62C13.0624 32.3625 13.0624 33.5644 13.8049 34.3068C14.176 34.678 14.6601 34.8626 15.1462 34.8626C15.6323 34.8626 16.1183 34.678 16.4894 34.3068L24.6423 26.1542L32.7947 34.3068C33.166 34.678 33.6522 34.8626 34.1382 34.8626C34.6221 34.8626 35.1082 34.678 35.4795 34.3068C36.222 33.5644 36.222 32.3625 35.4795 31.62L27.3268 23.4674Z",
    fill: "#FFFDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.4743080cae1c3919c3f1bcf20fda1ab8.svg";
export { ForwardRef as ReactComponent };